export default [
  {
    path: "/activity-tracker",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/activity-tracker",
        name: "activity-tracker",
        component: () => import("./ActivityTracker.vue"),
      },
    ],
  },
];
